import * as React from "react"
import {useSignal} from "@preact/signals-react";
import {Box, Grid} from "@mui/material";

import {useRepricingFormData} from "../../@hooks";
import RepricingCrudFormTitleRow from "../TitleRow";
import RepricingFormActionRuleSelect from "./ActionRule";
import RepricingFormActionRepricingSelect from "./ActionRepricing";
import RepricingFormActionChangeType from "./ActionChangeType";
import RepricingFormActionValue from "./ActionValue";
import RepricingFormEmailsTagField from "./Emails";


export default function RepricingCrudFormActionRow() {

	return <>
		<Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
			<Box>
				<RepricingCrudFormTitleRow
					icon="square-caret-right"
					title="Action"
					subtitle="Determine the action to take"
				/>
			</Box>
			<Box>
				<RepricingFormActionRuleSelect />
			</Box>
		</Grid>

		<Grid item xs={2}>
			<RepricingFormActionRepricingSelect />
		</Grid>

		<Grid item xs={2}>
			<RepricingFormActionChangeType />
		</Grid>

		<Grid item xs={2}>
			<RepricingFormActionValue />
		</Grid>

		<Grid item xs={2} />

		<Grid item xs={12}>
			<RepricingFormEmailsTagField />
		</Grid>
	</>
}